import { detectCreditCard } from '@vend/credit-card-detector'
import angular from 'angular'

/**
 * Validate note input to detect if it contains credit card details.
 *
 * @module webregister.directives.hasCreditCard
 */
angular
  .module('webregister.directives')
  .directive('hasCreditCard', function (vdFeatureManager) {
    'ngInject'
    return {
      restrict: 'A',
      require: 'ngModel',
      link(scope, el, attrs, ngModelCtrl) {
        ngModelCtrl!.$validators.hasCreditCard = (
          modelValue: $TSFixMe,
          viewValue: $TSFixMe
        ) => {
          if (vdFeatureManager.get('cardholder_data_validation_webregister')) {
            return !detectCreditCard(viewValue)
          } else {
            return true
          }
        }
      },
    }
  })
